export interface RecordExternal {
  recordId: string;
  externalLink: string;
}
export enum TypeAction {
  AWS_COURSES = 'AWS_COURSES',
  OPEN_URL = 'OPEN_URL',
}
